<template>
  <AppModal
    v-if="!loading"
    size="5xl"
    :title="`${framework?.name} Goals (${framework?.shortName})`"
    @close="$emit('close')"
  >
    <!-- Modal Body -->
    <template #body>
      <div
        class="mb-4"
        v-html="domPurify.sanitize(framework?.description) || 'No description provided'"
      />

      <span class="block mb-5">The {{ framework.goals?.length }} {{ framework?.name }} Goals are:</span>

      <FrameworkGoalAccordion :goals="framework.goals" />
    </template>
  </AppModal>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { ref } from 'vue';

import { AppModal } from '@/components/app';

import { useHttp } from '@/composables';
import { FrameworkGoalAccordion } from '@/components/framework';
import { useDomPurify } from '@/composables';

const domPurify = useDomPurify();

defineEmits(['close']);

const props = defineProps({
  frameworkId: {
    type: Number,
    default: null,
  },
});
const loading = ref(true);
const framework = ref(null);

const loadFramework = async () => {
  loading.value = true;
  const response = await useHttp().get(`/util/frameworks/${props.frameworkId}`);

  if (response.statusCode === HttpStatusCode.Ok) {
    framework.value = response.data;
  }

  loading.value = false;
};

loadFramework();

</script>
